/** Styl komponenty toast k tématu Erma */
export const ToastStyles = {
  borderRadius: 'var(--erma-border-radius-md)',
  iconSize: '1rem',
  width: '25rem',
  borderWidth: '0',
  transitionDuration: '2s',
  blur: "0",
  info: {
    background: 'var(--erma-blue-50)',
    borderColor: 'var(--erma-blue-20)',
    color: 'var(--erma-blue-600)',
    detailColor: 'var(--erma-slate-700)',
    shadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    closeButton: {
      hoverBackground: 'var(--erma-blue-100)',
      focusRing: {
        color: 'var(--erma-blue-600)',
        shadow: 'none'
      }
    }
  },
  success: {
    background: 'var(--erma-green-50)',
    borderColor: 'var(--erma-green-200)',
    color: 'var(--erma-green-600)',
    detailColor: 'var(--erma-slate-700)',
    shadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    closeButton: {
      hoverBackground: 'var(--erma-green-100)',
      focusRing: {
        color: 'var(--erma-green-600)',
        shadow: 'none'
      }
    }
  },
  error: {
    background: 'var(--erma-red-50)',
    borderColor: 'var(--erma-red-200)',
    color: 'var(--erma-red-600)',
    detailColor: 'var(--erma-slate-700)',
    shadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    closeButton: {
      hoverBackground: 'var(--erma-red-100)',
      focusRing: {
        color: 'var(--erma-red-600)',
        shadow: 'none'
      }
    }
  },
  warn: {
    background: 'color-mix(in srgb, var(--erma-yellow-500), transparent 36%)',
    borderColor: 'color-mix(in srgb, var(--erma-yellow-700), transparent 64%)',
    color: 'var(--erma-yellow-900)',
    detailColor: 'var(--erma-surface-700)',
    shadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    closeButton: {
      hoverBackground: 'rgba(255, 255, 255, 0.05)',
      focusRing: {
        color: 'var(--erma-yellow-500)',
        shadow: 'none'
      }
    }
  },
  content: {
    padding: '.8rem',
    gap: '1rem'
  },
  text: {
    gap: '0.5rem'
  },
  summary: {
    fontWeight: '700',
    fontSize: '1rem'
  },
  icon: {
    size: '1.25rem'
  },
  closeIcon: {
    size: '1rem'
  },
};
